export default __webpack_public_path__ + "static/media/rav-lg.c0291a8d.png";